import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="flex justify-center bg-gray-100 min-h-screen">
      <div className="max-w-5xl w-full mx-4 my-6 p-6 bg-white rounded-2xl shadow-lg overflow-y-auto">
        <h1 className="text-2xl font-bold mb-4 text-gray-900">
          Legal and Privacy Policies
        </h1>

        <p className="mb-4 text-gray-700">
          <strong>WE REQUEST YOU READ OUR TERMS CAREFULLY</strong>, AS THEY
          PROVIDE CLARITY AND IMPORTANT INFORMATION ON HOW WE COLLECT, USE AND
          STORE DIFFERENT TYPE OF DATA RELATED TO YOU.
        </p>

        <p className="mb-4 text-gray-700">
          “We”, “us” or “our” in this notice refers to <strong>ROAR<sup>AI</sup></strong>.
          “You” or “yours” refers to anyone who visits or leverages ROAR<sup>AI</sup>
          digital assets including but not limited to our website, coach web
          application and smartphone App (Apple App Store / Google Play Store).
        </p>

        <p className="mb-6 text-gray-700">
          By confirming you are 18 and consent, you acknowledge that we collect
          data. We collect and use your data in multiple ways.
        </p>

        {/* Section */}
        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          The Data We Collect
        </h2>
        <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
          <li>
            <strong>Communication Data:</strong> Information you provide via
            forms, email, text, or social media.
          </li>
          <li>
            <strong>Customer Data:</strong> Purchases, billing info, addresses,
            emails, phone numbers, and payment details.
          </li>
          <li>
            <strong>User Data:</strong> Website interactions, app usage,
            published submissions.
          </li>
          <li>
            <strong>Technical Data:</strong> IP, login, browser, device,
            location, analytics data.
          </li>
          <li>
            <strong>Marketing Data:</strong> Preferences for communication and
            promotions.
          </li>
        </ul>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          Sensitive Data
        </h2>
        <p className="mb-6 text-gray-700">
          We do not collect sensitive data (race, ethnicity, beliefs, sexual
          life, orientation, health, genetics, biometrics, political, union
          membership, or criminal records).
        </p>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          How We Use Data
        </h2>
        <p className="mb-4 text-gray-700">
          We process your data only for purposes it was collected for or those
          reasonably compatible. Automated decision-making or profiling is not
          used.
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
          <li>Provide services and deliver purchased goods.</li>
          <li>Maintain security, stability, backups, and records.</li>
          <li>Marketing, promotional activities, and business growth.</li>
          <li>Compliance with legal, tax, and reporting obligations.</li>
        </ul>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          Data Sharing
        </h2>
        <p className="mb-6 text-gray-700">
          Data may be shared with trusted service providers, advisers,
          government authorities (when legally required), or third parties in
          case of sale, transfer, or merger. All third parties must maintain
          confidentiality and process data per our instructions.
        </p>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">Security</h2>
        <p className="mb-6 text-gray-700">
          We apply strict measures to safeguard personal data. Only authorized
          employees and partners with legitimate business needs may access it.
          Data breaches will be reported as required by law.
        </p>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          Data Retention
        </h2>
        <p className="mb-6 text-gray-700">
          Personal data is retained only as long as needed. Certain customer
          records are kept for 6 years per tax law. Some anonymized data may be
          stored indefinitely for research/statistics.
        </p>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">
          California Residents (CCPA)
        </h2>
        <p className="mb-4 text-gray-700">
          If you are a California consumer, your rights include:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 mb-6">
          <li>Right to know what data is collected and shared.</li>
          <li>Right to request deletion of personal data.</li>
          <li>Right to opt-out of data sale (we do not sell your data).</li>
          <li>Right to non-discrimination for exercising your rights.</li>
        </ul>

        <h2 className="text-xl font-semibold mb-3 text-gray-900">Contact Us</h2>
        <p className="mb-6 text-gray-700">
          If you have any questions with respect to these terms, please contact
          us at:{" "}
          <a
            href="mailto:Contact@RoarAI.Fit"
            className="text-blue-600 underline"
          >
            Contact@RoarAI.Fit
          </a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
